import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgHlUser = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_457_24676)",
		children: [/* @__PURE__ */ _jsx("circle", {
			cx: 16,
			cy: 16,
			r: 16,
			fill: "#26272C"
		}), /* @__PURE__ */ _jsx("path", {
			d: "M16 9C17.0609 9 18.0783 9.42143 18.8284 10.1716C19.5786 10.9217 20 11.9391 20 13C20 14.0609 19.5786 15.0783 18.8284 15.8284C18.0783 16.5786 17.0609 17 16 17C14.9391 17 13.9217 16.5786 13.1716 15.8284C12.4214 15.0783 12 14.0609 12 13C12 11.9391 12.4214 10.9217 13.1716 10.1716C13.9217 9.42143 14.9391 9 16 9ZM16 11C15.4696 11 14.9609 11.2107 14.5858 11.5858C14.2107 11.9609 14 12.4696 14 13C14 13.5304 14.2107 14.0391 14.5858 14.4142C14.9609 14.7893 15.4696 15 16 15C16.5304 15 17.0391 14.7893 17.4142 14.4142C17.7893 14.0391 18 13.5304 18 13C18 12.4696 17.7893 11.9609 17.4142 11.5858C17.0391 11.2107 16.5304 11 16 11ZM16 18C18.67 18 24 19.33 24 22V25H8V22C8 19.33 13.33 18 16 18ZM16 19.9C13.03 19.9 9.9 21.36 9.9 22V23.1H22.1V22C22.1 21.36 18.97 19.9 16 19.9Z",
			fill: "white"
		})]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_457_24676",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 32,
			height: 32,
			rx: 16,
			fill: "white"
		})
	}) })]
});
export default SvgHlUser;
